import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {flattenDeep} from 'lodash';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {XmlParserService} from '../xml-parser.service';
import {Gpx, GpxTrack} from './models/gpx.model';
import {google} from '@google/maps';
import LatLngLiteral = google.maps.LatLngLiteral;

@Injectable({
  providedIn: 'root'
})
export class GpxParserService {

  constructor(private xml: XmlParserService,
              private http: HttpClient) {
  }

  getGpxFile(endpoint: string): Observable<Gpx> {
    return this.http.get(endpoint, {responseType: 'text'})
      .pipe(
        map((response: any) => {
          return this.xml.parse(response, {
            ignoreAttributes: false,
            attributeNamePrefix: ''
          });
        })
      );
  }

  /**
   * TODO: Optimise performance
   * @param gpxJson
   */
  geTrackPoints(gpxJson: Gpx): Array<LatLngLiteral> {
    if (Array.isArray(gpxJson.gpx.trk)) {
      gpxJson.gpx.trk = {
        trkseg: {
          trkpt: flattenDeep((gpxJson.gpx.trk as Array<GpxTrack>)
            .reduce((curr, prev) => {
              curr.push(prev.trkseg);
              return curr;
            }, []).reduce((curr, prev) => {
              curr.push(prev.trkpt);
              return curr;
            }, []))
        }
      } as GpxTrack;
    }
    if (!Array.isArray(gpxJson.gpx.trk.trkseg.trkpt)) {
      return [];
    }
    return gpxJson
      .gpx.trk.trkseg.trkpt
      .map(point => {
        return {
          lat: Number(point.lat),
          lng: Number(point.lon)
        };
      });
  }
}
